<app-data-table [colFields]="colFields" [tableData]="tableData"  (generateQREmitter)="QRCallback($event)"></app-data-table>
